import { getEndpoints, buildEndpoint } from "../utils/ApiContext";
import fetchWithAuth                   from "../utils/fetchWithAuth";

export const fetchServiceStatus = async serviceName => {
  try {
    await getEndpoints();
    const url = buildEndpoint("API_SERVICE_STATUS", serviceName);

    const resp = await fetchWithAuth(url);
    if (!resp.ok) throw new Error("Error al obtener el estado del servicio");

    return resp.json();
  } catch (err) {
    console.error("Error al intentar obtener el estado del servicio:", err);
    throw err;
  }
};